export { default as OrderRowCollapsedContentMobile } from './OrderRowCollapsedContentMobile';
export { default as OrderRowCollapsedContentDesktop } from './OrderRowCollapsedContentDesktop';
export type { OrderRowCollapsedContentProps } from './types';
